<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        发货提醒
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div style="width: 1056px;margin: 0 auto" v-if="role">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <!-- <el-table-column label width="40" v-model="select" type="selection"></el-table-column> -->
        <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
        <el-table-column prop="nickname" width="160" label="姓名" align="center"></el-table-column>
        <el-table-column prop="bind_mobile" width="160" label="手机号码" align="center"></el-table-column>
        <el-table-column prop="email" width="170" label="邮箱地址" align="center"></el-table-column>
        <el-table-column prop="pay_money" label="订单金额" align="center"></el-table-column>
        <el-table-column label="操作" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button
              v-if="scope.row.inform == 0"
              class="button1"
              @click="dialogFormVisible = true,alert1(scope.row)"
            >提醒</button>
            <button v-else class="button1">已提醒</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_box clearfix" v-if="total > 15">
        <div class="page">
          <el-pagination
            style="text-align:center"
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="15"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!--  编辑弹窗 -->
    <el-dialog title="到货提醒" :visible.sync="dialogFormVisible" width="500px">
      <el-form>
        <el-form-item label="提醒方式:">
          <template>
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false , submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../assets/all.css";
import $ from "jquery";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      tableData: [],
      page: null,
      total: null,
      value: "",
      option: [
        {
          label: "电话提醒",
          value: 1
        },
        {
          label: "短信提醒",
          value: 2
        },
        {
          label: "邮箱提醒",
          value: 3
        },
        {
          label: "在线提醒",
          value: 4
        }
      ],
      orderCode: "",
      mobile: "",
      tixing: false,
      //
      id: "",

      dialogFormVisible: false,

      selectAll: false,

      number: "",
      name: "",

      token: "",
      username: "",
      inventory: null,
      title: "",
      resType: null,
      numall: null,
      sousuo: "",
      //

      name: null,
      category: null,
      categorys: [],
      brand: null,
      brands: [],

      multipleSelection: [],
      isIndeterminate: true,
      select: false,

      checked: [],
      idString: ""
    };
  },
  created() {
    this.$store.state.leftTitle = "发货提醒";
    this.$store.state.topActiveId = 3;
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据

      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/shipments_inform_list", {
          params: {
            token: this.token,
            username: this.username,
            page: this.page
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            that.page = res.data.data.page;
            that.total = res.data.data.total;
            var json = res.data.data.results;
            this.tableData = [];
            for (var key in json) {
              that.tableData.push(json[key]);
            }
          } else {
            if (res.data.msg == "无权访问") {
              this.role = false;
            }
          }
        });
    },
    alert1(id) {
      //提醒弹窗
      this.orderCode = id.orderCode;
      this.mobile = id.mobile;
    },
    open2() {
      this.$message({
        message: "提醒成功",
        type: "success"
      });
    },
    open4() {
      this.$message.error("请选择提醒方式");
    },
    submit() {
      // const loading = this.$loading({
      // lock: true,
      // text: "正在上传",
      // spinner: "el-icon-loading",
      // background: "rgba(0, 0, 0, 0.7)"
      // });
      var _this = this;
      this.axios
        .get(this.serve + "/admin/shipments_inform", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: this.orderCode,
            type: this.value,
            mobile: this.mobile
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            _this.value = null;
            _this.geting();
            _this.open2();
          } else if (res.data.status == "error") {
            _this.open4();
          }
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>